<template>
  <div style="width:100%;height:100%;">
      <ListaAttivita></ListaAttivita>
  </div>
</template>
<script>

import ListaAttivita from "@/components/TOOLS/ListaAttivita.vue";
export default {
     components: {
    ListaAttivita,
  },
  data() {
      
    return {
        
        
    };
  },
};
</script>